import OrganizationTypeList from "../../slices/organization/OrganizationTypeList";

const organizationReducer = {
    organizationTypeList: OrganizationTypeList,
};

export default organizationReducer;